import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Form, Formik } from "formik";
import { ReactElement } from "react";
import * as yup from "yup";

import { FormikTextField } from "~frontend/components/forms/FormTextField";
import FormikErrorBanner from "~frontend/components/forms/FormikErrorBanner";

type Values = { name: string };

export default function CreateTagDialog({
  open,
  onSubmit,
  onClose,
}: {
  open: boolean;
  onSubmit: (values: Values) => Promise<void>;
  onClose: () => void;
}): ReactElement {
  return (
    <Dialog open={open}>
      <DialogTitle>New Tag</DialogTitle>
      <Formik
        initialValues={{ name: "" }}
        onSubmit={async (values, formik) => {
          await onSubmit(values);
          formik.resetForm();
          onClose();
        }}
        validationSchema={yup
          .object()
          .shape({ name: yup.string().required("Required") })}
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogContent>
              <FormikErrorBanner />
              <FormikTextField fullWidth label="Tag Name" name="name" />
            </DialogContent>
            <DialogActions>
              <Button disabled={isSubmitting} onClick={onClose} color="primary">
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                color={"primary"}
                variant="contained"
              >
                {isSubmitting ? "Saving..." : "Save"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
